var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"border-variant":"dark"}},[_c('div',{attrs:{"id":"chart1"}},[_c('apexchart',{ref:"realtimeResp",attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }